import { z } from 'zod';
import { defineListQuery, listFilter } from './list-query.schemas';

export const TRAILER_STATUSES = ['active', 'inactive'] as const;
export type TrailerStatus = (typeof TRAILER_STATUSES)[number];

/** `POST /trailers` and `PATCH /trailers/:id` — status changes go through their own `activate`/`deactivate` routes. */
export const createTrailerSchema = z.object({
  registration: z.string().trim().min(1).max(32),
  typeCode: z.string().trim().min(1).max(32),
  capacityTonnes: z.number().positive(),
  axleCount: z.number().int().positive(),
  isSkeletal: z.boolean(),
  isFlatRack: z.boolean(),
  isReefer: z.boolean(),
});
export type CreateTrailerInput = z.infer<typeof createTrailerSchema>;

export const updateTrailerSchema = createTrailerSchema;
export type UpdateTrailerInput = z.infer<typeof updateTrailerSchema>;

/** `GET /trailers` — search matches registration. */
export const trailerListQuerySchema = defineListQuery({
  sortFields: ['registration', 'createdAt'],
  defaultSort: { sort: 'registration', order: 'asc' },
  filters: {
    status: listFilter(z.enum(TRAILER_STATUSES)),
  },
});
export type TrailerListQuery = z.infer<typeof trailerListQuerySchema>;
